module.exports = new __parcel__URL__("premium-trial.bdfe4386.svg").toString();